<template>
  <div>
    <van-sticky>
       <van-nav-bar v-if="!environment" left-arrow @click-left="onClickLeft"> </van-nav-bar>
    </van-sticky>
    <img class="img" src="@/assets/guizhe.jpg" alt="" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      environment: false
    }
  },
  components: {},
  created(){
    this.getIsWxMiniProgram()
  },
  methods: {
    // 判断是否小程序
    async getIsWxMiniProgram() {
      const WxMiniProgram = await this.$getIsWxMiniProgram()
      if (WxMiniProgram) {
        this.environment = true
      } else {
        this.environment = false
      }
    },
    onClickLeft() {
      this.$callApp('Android', 'GoBackAppMethod', '')
      this.$callApp('iOS', 'GoBackAppMethod', '')
    },
  },
}
</script>

<style scoped lang="less">

.img{
  vertical-align: middle;
  min-height: 100vh;
  width: 375px;

}
</style>
